import StageCard from "../../ProgressStep/StageCard";
import { Button } from "antd";
import React from "react";
import styles from "./style.module.scss";

interface AddClassCardProps {
  onClick: () => void;
}

export default function AddClassCard({ onClick }: AddClassCardProps) {
  return (
    <StageCard
      content={
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button className={styles.addClassButton} onClick={onClick}>
            Add Class
          </Button>
        </div>
      }
    />
  );
}
